import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  UrlTree,
} from '@angular/router';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { AuthServiceProvider } from './auth.service';

/**
 * Keeps the school-manager subscription views off until the environment
 * enables them; phase 1 ships the admin views only. An admin logged in as a
 * manager keeps access, since the admin tools reach the member views that way.
 */
@Injectable({
  providedIn: 'root',
})
export class ManagerSubscriptionsGuardService implements CanActivate {
  constructor(
    private router: Router,
    private authService: AuthServiceProvider,
  ) {}

  /** Whether the manager-area subscription views may be shown to the current user. */
  isAvailable(): Observable<boolean> {
    if (environment.isManagerSubscriptionsVisible) {
      return of(true);
    }
    return this.authService.get().pipe(map((auth) => auth.isLoggedInAsManager()));
  }

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> {
    return this.isAvailable().pipe(
      map((available) => {
        if (available) {
          return true;
        }
        const schoolId = route.pathFromRoot
          .map((r) => r.paramMap.get('schoolId'))
          .find((id) => id != null);
        return this.router.createUrlTree(
          schoolId ? ['school', schoolId, 'dashboard'] : ['/'],
        );
      }),
    );
  }
}
